import { Button, Dialog, DialogContent, DialogTitle, MenuItem, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { PaymentPerProductDialog } from './PaymentPerProductDialog';
import { PaymentTypesContext } from './PaymentTypesContext';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { currencyServices } from 'src/services/reservation/currency/currency.service';
import { businessUnitPerProductServices } from 'src/services/payment/businessUnitPerProduct/BusinessUnitPerProduct.service';

export const ArrayInputPaymentsPerProduct = ({businessUnitId, payment, isShow, setIspaymentPerProductScreen}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [selectedProduct, setSelectedProduct] = useState(payment ? payment[0].product_id :'')
    const [activateOnlinePayments, setActivateOnlinePayments] = useState(payment ? payment[0].is_active : false)
    const [paymentsPerProduct, setPaymentsPerProduct] = useState(payment ? payment : [])
    const [openDialog, setOpenDialog] = useState(false)
    const [paymentToEdit, setPaymentToEdit] = useState(null)
    const { paymentTypes, setCurrencies, currencies, availableProducts, setIdCount} = useContext(PaymentTypesContext);
    const [paymentsEdited, setPaymentsEdited] = useState([])
    const [submitLoading, setSubmitLoading] = useState(false)
    const [paymentsToDelete, setPaymentsToDelete] = useState([])

    useEffect(()=>{
        getCurrencies()
        const currentId = Math.max(...paymentsPerProduct.map(pay=>pay.id));
        setIdCount(currentId + 1)
        /* if(payment){
            let optionsToRemove = []
            for(let pay of payment){
                optionsToRemove.push(pay.payment_type_id)
            }
            setAvailablePaymentTypes(availablePayments=>availablePayments.filter(pay=>!optionsToRemove.includes(pay.id)))
        } */
    },[])

    const getCurrencies = () =>{
        currencyServices.getByAll().then(res=>{
            setCurrencies(res)
        })
    }

    useEffect(()=>{
        if(paymentToEdit){
            setOpenDialog(true)
        }
    },[paymentToEdit])

    useEffect(()=>{
        if(!openDialog){
            setPaymentToEdit(null)
        }
    },[openDialog])

    const getPaymentTypeName = (id) =>{
        return paymentTypes.find(item=>item.id === id)?.long_name
    }

    const onSubmit = async  () =>{
        setSubmitLoading(true)
        let finishCount = 0
        let okCount = 0
        let riseError = false
        for(let paymentPerProduct of paymentsEdited){
            const extraFields = {
                business_unit_id:businessUnitId,
                product_id:selectedProduct, 
                is_active:activateOnlinePayments
            }
            if(paymentPerProduct.id){
                const id = paymentPerProduct.id
                delete paymentPerProduct.id
                await businessUnitPerProductServices.editProductsByBusinessUnit(
                    id,{...paymentPerProduct,...extraFields}
                ).finally(()=>{
                    finishCount ++
                }).then(()=>{
                    okCount ++
                }).catch(()=>{
                    riseError=true
                })
            } else {
                await businessUnitPerProductServices.createProductsByBusinessUnit({...paymentPerProduct,...extraFields}).finally(()=>{
                    finishCount ++
                }).then(()=>{
                    okCount ++
                }).catch(()=>{
                    riseError=true
                })
            }
            
        }
        for(let pay of paymentsToDelete){
            await businessUnitPerProductServices.deleteProductsByBusinessUnit(pay).then(()=>{
                okCount ++
            }).finally(()=>{
                finishCount ++
            }).catch(()=>{
                riseError=true
            })
            
        }
        if(riseError){
            setSubmitLoading(false)
            notify('ra.notification.updated_error_femenine',{type:'error', messageArgs:{element:translate('ra.single_entity.work-unit')}})
        }
        if(finishCount === (paymentsEdited.length + paymentsToDelete.length)){
            setSubmitLoading(false)
        }
        if(okCount === (paymentsEdited.length + paymentsToDelete.length)){
            notify('ra.notification.updated_success_femenine',{type:'success', messageArgs:{element:translate('ra.single_entity.business-unit')}})
            setIspaymentPerProductScreen(false)
        }
    }

    const onDelete = (row) =>{
        if(row.id){
            setPaymentsToDelete(paymentTodelete => [...paymentTodelete, row.id])
            setPaymentsPerProduct(paymentsPerProduct=>paymentsPerProduct.filter(pay=> !pay.id || (pay.id && pay.id !== row.id)))
            setPaymentsEdited(paymentsPerProduct=>paymentsPerProduct.filter(pay=>(pay.id && pay.id !== row.id)))
        } else {
            setPaymentsPerProduct(paymentsPerProduct=>paymentsPerProduct.filter(pay=>!pay.auxId || (pay.auxId && pay.auxId !== row.auxId)))
            setPaymentsEdited(paymentsPerProduct=>paymentsPerProduct.filter(pay=>!pay.auxId || (pay.auxId && pay.auxId !== row.auxId)))
        }
        /* setAvailablePaymentTypes(paymentTypesArray => [...paymentTypesArray, paymentTypes.find(pay=>pay.id === row.payment_type_id)]) */
    }

    const onChangeIsActivate = () =>{
        setPaymentsEdited(paymentsPerProduct)
        setActivateOnlinePayments(!activateOnlinePayments)
    }

    const getCurrencyName = (id) =>{
        return currencies.find(cur=>cur.id === id)?.long_name
    }

    const formatTimeConfig = (time_config) =>{
        let from_pivot = time_config[0].from
        let to_pivot = time_config[0].to
        let is_regular = true
        for(let time of time_config){
            if(time.from !== from_pivot || time.to !== to_pivot){
                is_regular = false
                break
            }
        }
        if(is_regular){
            return(
                <label>
                    {`${translate('ra.message.every_day')} ${from_pivot}-${to_pivot}`}
                </label>
            )
        }
        return(
            time_config?.map(time=>(
                <>
                    {(time.from !== '00:00:00' || time.to !== '00:00:00') &&
                        <label>
                            {`${time.name} ${time.from}-${time.to}`}
                        </label>
                    }
                </>
            ))
        )
    }
  return (
    <div>
        <label>
            {translate('ra.message.payment_product_decription')}
        </label>
        <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{marginTop:'15px'}}>
                <label htmlFor="product">
                    {translate('ra.field.product')}
                </label>
                <TextField
                    select
                    id='product'
                    size="small"
                    disabled={payment}
                    fullWidth
                    variant="outlined"
                    value={selectedProduct}
                    onChange={(e) =>setSelectedProduct(e.target.value)}
                >
                    {availableProducts.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.label}
                    </MenuItem>
                    ))}
                </TextField>
            </div>
            <div style={{marginTop:'15px', display:'flex', flexDirection:'column', marginLeft:'15px'}}>
                <label htmlFor="paymentsContainer">
                    {translate('ra.action.enable_online_payments')}
                </label>
                <div id='paymentsContainer' style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <Switch disabled={isShow} id='paymentsSwitch' checked={activateOnlinePayments} onChange={onChangeIsActivate}/>
                    <label htmlFor="paymentsSwitch">
                        {activateOnlinePayments ? translate('ra.field.is_active'): translate('ra.field.is_not_active')}
                    </label>
                </div>
            </div>
        </div>
        <TableContainer>
            <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{translate('ra.field.payment_methods')}</TableCell>
                    <TableCell>{translate('ra.field.currency')}</TableCell>
                    <TableCell>{translate('ra.field.weekly_availability')}</TableCell>
                    {isShow && <TableCell></TableCell>}
                </TableRow>
            </TableHead>

            <TableBody>
                {(paymentsPerProduct?.map((row, i) => (
                    <TableRow key={i}>
                        <TableCell>{getPaymentTypeName(row.payment_type_id)}</TableCell>
                        <TableCell>{getCurrencyName(row.currency_id)}</TableCell>
                        <TableCell style={{display:'flex', flexDirection:'column'}}>
                            {
                                formatTimeConfig(row.time_config)
                            }
                        </TableCell>
                        {!isShow && <TableCell>
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                <EditIcon 
                                    onClick={()=>{
                                        setPaymentToEdit(row)
                                    }}
                                    color='info' 
                                    style={{cursor:'pointer'}}
                                />
                                <DeleteIcon 
                                    color='error' 
                                    style={{cursor:'pointer'}}
                                    onClick={()=>onDelete(row)}
                                />
                            </div>
                        </TableCell>}
                    </TableRow>
                    ))
                )}
            </TableBody>
            </Table>
        </TableContainer>
        {!isShow && <Button
            onClick={()=>{setOpenDialog(true)}}
            variant='outlined' 
            style={{display:'flex', flexDirection:'row', marginTop:'15px'}}>
            <AddIcon/>
            {translate('ra.action.add_payment_method')}
        </Button>}
        <Dialog
            open={openDialog}
            onClose={()=>setOpenDialog(false)}
            fullWidth
            maxWidth={'lg'}
        >
            <DialogTitle>
                {'Instancia de pago'}
            </DialogTitle>
            <DialogContent>
                <PaymentPerProductDialog setOpenDialog={setOpenDialog} setPaymentsPerProduct={setPaymentsPerProduct} paymentPerProduct={paymentToEdit} setPaymentsEdited={setPaymentsEdited}/>
            </DialogContent>
        </Dialog>

        {!isShow ? <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <LoadingButton
                style={{marginTop:'15px'}}
                variant='contained'
                loading={submitLoading}
                startIcon={
                    <SaveIcon/>
                }
                onClick={onSubmit}
            >
                {translate('ra.action.save_payment_instance')}
            </LoadingButton>
                <Button
                style={{marginTop:'15px'}}
                variant='contained'
                onClick={()=>setIspaymentPerProductScreen(false)}
            >
                {translate('ra.action.back')}
            </Button>
        </div>:
        <Button
            style={{marginTop:'15px'}}
            variant='contained'
            onClick={()=>setIspaymentPerProductScreen(false)}
        >
            {translate('ra.action.back')}
        </Button>
        }
    </div>
  )
}